"use client";

import { Facebook, Instagram, Star, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer({
  heading
}: {
  heading: string;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  return <div>
      <div className="flex items-center gap-2 mb-5">
        <span className="inline-block w-2 h-2 bg-primary" />
        <span className="font-default text-xs tracking-[0.18em] uppercase text-muted-foreground">
          {heading}
        </span>
      </div>
      {loading ? <div className="flex flex-col gap-3">
          <div className="h-4 w-28 bg-muted/10 animate-pulse" />
          <div className="h-4 w-32 bg-muted/10 animate-pulse" />
          <div className="h-4 w-24 bg-muted/10 animate-pulse" />
          <div className="h-4 w-30 bg-muted/10 animate-pulse" />
        </div> : <ul className="flex flex-col gap-3">
          {menuItems.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-foreground font-default text-sm tracking-[0.1em] uppercase text-foreground/80 hover:text-primary relative inline-block group transition-colors duration-200">
                <span>{item.label}</span>
                <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
              </Link>
            </li>)}
        </ul>}
    </div>;
}
const servicesList = [{
  label: "AUTO COVERAGE",
  href: "#"
}, {
  label: "HOME PROTECTION",
  href: "#"
}, {
  label: "LIFE ASSURANCE",
  href: "#"
}, {
  label: "BUSINESS RISK",
  href: "#"
}, {
  label: "UMBRELLA POLICY",
  href: "#"
}];
const hoursList = [{
  day: "MON-FRI",
  time: "8A-7P",
  openDays: [1, 2, 3, 4, 5]
}, {
  day: "SAT",
  time: "9A-3P",
  openDays: [6]
}, {
  day: "SUN",
  time: "CLOSED",
  openDays: []
}];
const socialLinks = [{
  icon: Facebook,
  label: "Facebook",
  href: "#"
}, {
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  icon: MapPin,
  label: "Google",
  href: "#"
}, {
  icon: Star,
  label: "Yelp",
  href: "#"
}];
function getCurrentDay() {
  if (typeof window === "undefined") return -1;
  return new Date().getDay();
}
export default function AgencyFooter() {
  const today = getCurrentDay();
  return <section data-section-id="1877" id="agency-footer" className="dark bg-background text-foreground py-20 relative">
      {}
      <div className="absolute top-0 left-0 right-0 h-2 w-full" style={{
      backgroundImage: "repeating-linear-gradient(45deg, hsl(155 85% 35%) 0px, hsl(155 85% 35%) 6px, hsl(215 45% 7%) 6px, hsl(215 45% 7%) 12px)"
    }} aria-hidden="true" />

      <div className="max-w-[1360px] mx-auto px-6 md:px-10 lg:px-16 pt-8">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10">
          {}
          <div className="lg:col-span-9 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {}
            <div data-index={0}>
              <Link to="/" className="inline-block mb-6">
                <WvcLogo className="h-8 w-auto" />
              </Link>
              <div className="flex items-center gap-2 mb-4">
                <span className="inline-block w-2 h-2 bg-primary" />
                <span className="font-default text-xs tracking-[0.18em] uppercase text-muted-foreground">
                  VANGUARD SHIELD
                </span>
              </div>
              <address className="not-italic font-default text-sm tracking-[0.08em] uppercase text-foreground/80 leading-relaxed">
                NEW YORK, NY
                <br />
                10001
                <br />
                <Link to="tel:+12125550199" className="text-foreground hover:text-primary transition-colors">
                  (212) 555-0199
                </Link>
              </address>
            </div>

            {}
            <div data-index={1}>
              <MenuProvider menu_id="2">
                <FooterMenuConsumer heading="NAVIGATE" />
              </MenuProvider>
            </div>

            {}
            <div data-index={2}>
              <div className="flex items-center gap-2 mb-5">
                <span className="inline-block w-2 h-2 bg-primary" />
                <span className="font-default text-xs tracking-[0.18em] uppercase text-muted-foreground">
                  COVERAGE
                </span>
              </div>
              <ul className="flex flex-col gap-3">
                {servicesList.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.href} className="text-foreground font-default text-sm tracking-[0.1em] uppercase text-foreground/80 hover:text-primary relative inline-block group transition-colors duration-200">
                      <span>{item.label}</span>
                      <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div data-index={3}>
              <div className="flex items-center gap-2 mb-5">
                <span className="inline-block w-2 h-2 bg-primary" />
                <span className="font-default text-xs tracking-[0.18em] uppercase text-muted-foreground">
                  SUPPORT
                </span>
              </div>
              <table className="w-full font-default text-sm">
                <tbody>
                  {hoursList.map((row, i) => {
                  const isOpen = row.openDays.includes(today);
                  return <tr key={row.day} data-index={i} className="border-b border-border last:border-b-0">
                        <td className="py-2 tracking-[0.08em] uppercase text-foreground/80">
                          <span className="flex items-center gap-2">
                            {isOpen && <span className="inline-block w-2 h-2 bg-primary" aria-label="Currently open" />}
                            {!isOpen && <span className="inline-block w-2 h-2" />}
                            {row.day}
                          </span>
                        </td>
                        <td className="py-2 tracking-[0.08em] uppercase text-right text-foreground/80">
                          {row.time}
                        </td>
                      </tr>;
                })}
                </tbody>
              </table>
            </div>
          </div>

          {}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2 mb-5">
              <span className="inline-block w-2 h-2 bg-primary" />
              <span className="font-default text-xs tracking-[0.18em] uppercase text-muted-foreground">
                EMERGENCY CLAIMS
              </span>
            </div>
            <Link to="tel:+12125550199" className="text-foreground block mb-6 group">
              <span className="block font-default font-bold text-primary leading-none tracking-tight" style={{
              fontSize: "clamp(1.5rem, 2.4vw, 2.25rem)"
            }}>
                24/7
                <br />
                SUPPORT
              </span>
              <span className="block mt-2 font-default text-xs tracking-[0.18em] uppercase text-muted-foreground group-hover:text-primary transition-colors">
                TAP TO CALL
              </span>
            </Link>

            <div className="mb-6">
              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-default font-bold uppercase tracking-[0.06em] px-6 py-3 h-auto text-sm">
                <Link to="/ClaimsCenterPage">FILE A CLAIM</Link>
              </Button>
            </div>

            {}
            <div className="flex items-center gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} aria-label={social.label} data-index={i} className="text-foreground w-11 h-11 border border-border flex items-center justify-center hover:bg-primary hover:border-primary hover:text-primary-foreground transition-all duration-200">
                    <Icon className="w-4 h-4" strokeWidth={1.75} />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 mb-6 h-3 w-full" style={{
        backgroundImage: "repeating-linear-gradient(45deg, hsl(155 85% 35%) 0px, hsl(155 85% 35%) 8px, hsl(215 45% 7%) 8px, hsl(215 45% 7%) 16px)"
      }} aria-hidden="true" />

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-default text-xs tracking-[0.1em] uppercase text-muted-foreground">
          <div>
            © 2025 VANGUARD SHIELD INSURANCE · SECURE · RELIABLE
          </div>
          <div className="flex items-center gap-4">
            <Link to="#" className="text-foreground text-muted-foreground hover:text-primary transition-colors">
              PRIVACY
            </Link>
            <Separator orientation="vertical" className="h-3 bg-border" />
            <Link to="#" className="text-foreground text-muted-foreground hover:text-primary transition-colors">
              TERMS
            </Link>
            <Separator orientation="vertical" className="h-3 bg-border" />
            <Link to="#" className="text-foreground text-muted-foreground hover:text-primary transition-colors">
              SITEMAP
            </Link>
          </div>
        </div>
      </div>
    </section>;
}